import React, { useContext } from 'react';
import { TableContext } from '../../../../contexts/TableContext';
import { RowClassName } from '../../../../enums';
import { VALIDATION_FIELD_MAPPING } from '../../../../utils/appConstant';
import ElipsisCell from '../../../../components/TableBox/Cells/EllipsisCell';

interface CalculationPopoverRowProps {
  item: {
    name: string;
    amount: string;
    platformCommission: string;
    net: string;
  };
  className?: RowClassName;
}

const CalculationPopoverRow: React.FC<CalculationPopoverRowProps> = ({ item, className }) => {
  const { headCells } = useContext(TableContext);

  return (
    <tr className={className}>
      {headCells.map((headCell) => {
        if (headCell.id === VALIDATION_FIELD_MAPPING.name) {
          return (
            <ElipsisCell
              key={headCell.id}
              width={headCell.width}
              text={item.name}
            />
          );
        }
        if (headCell.id === VALIDATION_FIELD_MAPPING.amount) {
          return (
            <td key={headCell.id}>
              {item.amount}
            </td>
          );
        }
        if (headCell.id === VALIDATION_FIELD_MAPPING.platformCommission) {
          return (
            <td key={headCell.id}>
              {item.platformCommission}
            </td>
          );
        }
        if (headCell.id === VALIDATION_FIELD_MAPPING.net) {
          return (
            <td key={headCell.id} className="fw-bold">
              {item.net}
            </td>
          );
        }
        return null;
      })}
    </tr>
  );
};

export default CalculationPopoverRow;

